export function runCommandLayer({
  twin,
  decision,
  intervention,
  mode = "ASSISTED", // ASSISTED | SUPERVISED | AUTONOMOUS
}) {
  if (!twin) return null;

  let authority = "advisory";

  if (twin.simulatedRisk === "CRITICAL") {
    authority =
      mode === "AUTONOMOUS"
        ? "execute"
        : mode === "SUPERVISED"
        ? "requestApproval"
        : "advise";
  }

  return {
    authority,
    message:
      authority === "execute"
        ? "executingProtocol"
        : authority === "requestApproval"
        ? "approvalRequired"
        : "guidanceProvided",
    recommendedActions: decision?.recommendedActions || [],
    timeline: intervention?.timeline || [],
  };
}
